<template>
  <div></div>
</template>

<script>
import {jsPDF} from "jspdf";
import vFormAndProjectMixin from "./vFormAndProjectMixin.js.vue";
import DateMixinJs from "../../mixins/DateMixin.js.vue";
import exportSlideImageMixin from '@/components/vFormImportExport/exportSlideImageMixin';
import {DEFAULT_EXPORT_IMAGE_QUALITY, normalizeImageQuality, fitImage} from '@/components/vFormImportExport/exportImageQuality';
import {parse} from "node-html-parser";
import {
  vFormControls
} from "../../../enum";

import './NotoSansSC-Regular-normal';
import './Amiri-Regular-normal';
import './NotoSansDevanagari_Condensed-Regular-normal';

export default {
  name: "toPDFMixin.js",
  mixins: [vFormAndProjectMixin, DateMixinJs, exportSlideImageMixin],
  data() {
    return {
      footer: {
        name: "",
        website: "",
        logo: null
      },
      pdf: {
        processing: false,
        ExportProcessing: false,
        topOffset: 20,
        currentPage: 1,
        totalPages: 0,
        fillData: [],
        userId: null,
        sessionId: null,
        footerData: "",
        stepData: "",
        initialDate: null,
        useComponentLogs: false,
        renderGlobalPanels: false,
        imageQuality: DEFAULT_EXPORT_IMAGE_QUALITY
      },
      pdfConfig: {
        tileHeight: 40,
        tileWidth: 40,
        evenTileOffsetLeft: 51,
        tileOdd: true,
        buttonImageWidth: 33,
        slideImageWidth: 100,
        standardImageWidth: 80,
        maxLengthForShortAnswerText: 70,
        minHeightForShortAnswerBox: 33,
        fileName: "",
        topOffset: 20,
        processing: false,
        logoId: null,
        elementsLeftOffset: 10,
        FONT_SIZE: 10,
        NEW_PAGE_TOP_OFFSET: 20,
        PAGE_HEIGHT: 250,
        MAX_IMAGE_TOP_OFFSET: 220,
        currentRowHeight: 40,
        isFormRTL: false
      },
    };
  },
  methods: {
    getNewestStepLogEntry(step) {
      if (this.pdf.fillData && this.pdf.fillData.length) {
        const stepItems = this.pdf.fillData.filter(item => {
          return item.target === step.uuid;
        })
        if (stepItems && stepItems.length) {
          const stepItemSorted = stepItems.sort((a, b) => {
            return b.time - a.time;
          })
          return stepItemSorted[0]; // select the newest entry
        }
      }
      return {};
    },
    getNewestLogEntryForElement(element, step) {
      const stepItem = this.getNewestStepLogEntry(step);
      if (stepItem) {
        return this.getMatchingLogForQuestion(element, this.getLabel(element, 'unknown'), stepItem.data);
      }
      return null;
    },
    setFooterInfo(currentItem) {
      if (currentItem && currentItem.userId) {
        this.pdf.footerData = currentItem.userId + ' - ' + this.dateTimeFromUnix(currentItem.time);
        this.pdf.stepData = currentItem.userId + ' - ' + this.dateTimeFromUnix(currentItem.time);
        if (!this.pdf.initialDate) {
          this.pdf.initialDate = this.dateTimeFromUnix(currentItem.time).replaceAll(' ', '--').replaceAll(':', '-');
        }
      }
    },
    getMatchingLogForQuestion(element, question, data) {
      if (data && data.length) {
        const index = data.findIndex(item => {
          return item.elementId === element.uuid;
        })
        if (index !== -1) {
          return data[index]
        }
      }
      return null;
    },
    getMatchingOption(option, data) {
      if (!data) {
        return false;
      }
      const index = data.findIndex(item => {
        return item.optionId === option.uuid;
      })
      if (index !== -1) {
        return !!data[index].selected;
      }
      return false;
    },
    getOffsetTop() {
      return this.pdfConfig.topOffset
    },
    setOffsetTop(num) {
      this.pdfConfig.topOffset = num;
    },
    addOffsetTop(num) {
      this.pdfConfig.topOffset += num;
    },
    resetOffsetTop() {
      this.pdfConfig.topOffset = this.pdfConfig.NEW_PAGE_TOP_OFFSET;
    },
    getImage(config, lang) {
      if (config.label.imageDix) {
        const defaultImg = config.label.imageDix.Unknown;
        const langImg = config.label.imageDix[lang];
        return langImg ? langImg : defaultImg;
      }
    },
    async getAssetUri(logoId) {
      return await this.$store.dispatch("clientLoadAsset", {id: logoId})
          .then(asset => {
            return asset.previewUri;
          }).catch(err => {
            this.$log.debug(err);
            return null;
          });
    },
    async getAssetFileAsBase64(logoId) {
      let previewUri = await this.getAssetUri(logoId);
      if (!previewUri) {
        return;
      }
      let arr = previewUri.split('/');
      let key = arr[arr.length - 1];
      return await this.$store.dispatch('clientDownloadAsset', {id: logoId, key: key})
          .then(async (data) => {
            const arrayBuffer = await new Response(data.text).arrayBuffer();
            return new Buffer(arrayBuffer, "binary").toString("base64");
          }).catch(err => {
            this.$log.error(err)
            return "";
          });
    },
    async setBasicOrganizationData(organizationId) {
      await this.$store.dispatch('loadOrganization', {
        id: organizationId,
        include: 'metaSets'
      }).then(data => {
        this.footer.name = data.displayName;
        this.footer.website = data.url;
        let metaValues = this.smashMetaSets(data.metaSets);
        this.pdf.logoId = metaValues.themeImage;
      })
    },
    setUpLogData(dataConfig = {}) {
      const {fillData, sessionId, userId, useComponentLogs, renderGlobalPanels, imageQuality, isFormRTL = false} = dataConfig;
      this.pdf.imageQuality = normalizeImageQuality(imageQuality);
      this.pdfConfig.isFormRTL = isFormRTL;
      if (fillData && fillData.length) {
        this.pdf.fillData = fillData;
        this.pdf.sessionId = sessionId;
        this.pdf.userId = userId;
        this.pdf.useComponentLogs = useComponentLogs;
        this.pdf.renderGlobalPanels = renderGlobalPanels;
      } else {
        this.pdf.fillData = [];
        this.pdf.sessionId = null;
        this.pdf.userId = null;
        this.pdf.useComponentLogs = false;
        this.pdf.renderGlobalPanels = false;
      }
      this.pdfConfig.topOffset = 20;
    },
    async toPDF(organizationId, projectId, vFormId, slides, config, loadingMode = 'current', dataConfig) {
      let images = {};
      this.setUpLogData(dataConfig);
      this.$emit('addingPage', 0)
      this.setPDFAddingPage(0);

      // eslint-disable-next-line no-unreachable
      this.pdf.processing = true;
      this.pdf.totalPages = slides.length;
      this.setPDFTotalPages(this.pdf.totalPages)
      this.$emit('totalPages', this.pdf.totalPages)

      await this.setBasicOrganizationData(organizationId);

      const {slideImageWidth, isFormRTL, elementsLeftOffset} = this.pdfConfig;

      const {logoId} = this.pdf;
      if (logoId) {
        this.pdf.logo = await this.getAssetFileAsBase64(logoId);
      }

      const doc = new jsPDF();
      doc.setFontSize(this.pdfConfig.FONT_SIZE);

      const selectedLanguage = this.$store.getters.getSelectedFormLanguage;
      if (selectedLanguage === 'Simplified Chinese' || selectedLanguage === 'Russian') {
        doc.setFont("NotoSansSC-Regular");
      } else if (selectedLanguage === 'Hindi') {
        doc.setFont("NotoSansDevanagari_Condensed-Regular");
      } else if (selectedLanguage.includes('Arabic')) {
        doc.setFont("Amiri-Regular");
      }

      //doc.addFileToVFS("NotoSansSC-Regular.ttf", fontBase64);
      //doc.addFont("NotoSansSC-Regular.ttf", "NotoSansCJKsc", "normal");
      for (let i = 0; i < slides.length; i++) {
        this.pdf.currentPage = i + 1;
        this.$emit('addingPage', this.pdf.currentPage)
        this.setPDFAddingPage(this.pdf.currentPage);
        const slide = slides[i];
        const {id} = slide;
        const step = config.steps.find((step) => {
          return step.linkedSlides.find((s) => {
            return s === id
          });
        });
        if (step) {
          const data = this.getNewestStepLogEntry(step);
          if (data) {
            this.setFooterInfo(data);
          }
        }
        if (step && i > 0) {
          this.addPageToPdf(doc);
        } else if (i === 0) {
          this.addHeaderFooter(doc);
        }

        if (step && step.elements) {
          //add step elements
          const slideImageTopOffset = this.getOffsetTop();
          const pageNumber = doc.getCurrentPageInfo().pageNumber;
          this.resetOffsetTop();
          const offsetLeft = isFormRTL ? elementsLeftOffset + 82 : 10;
          this.addTextToPdf({
            doc,
            leftOffset: offsetLeft,
            text: `Slide Nr: ${i + 1} / ${slides.length}`,
            textAlign: isFormRTL ? 'right' : 'left',
          })
          this.addTextToPdf({
            doc,
            leftOffset: offsetLeft,
            text: `Step Nr: ${step.step}`,
            textAlign: isFormRTL ? 'right' : 'left',
          })
          if (this.pdf.stepData) {
            this.addTextToPdf({
              doc,
              leftOffset: offsetLeft,
              text: `Log: ${this.pdf.stepData}`,
              textAlign: isFormRTL ? 'right' : 'left',
            })
          }
          if (this.pdf.renderGlobalPanels) {
            const globalPanels = config.global.panels;
            for (let j = 0; j < globalPanels.length; j++) {
              const {uuid} = globalPanels[j];
              const elements = this.getElementsByPanel(uuid, config.global, step, false);
              const filtered = elements.filter(item => {
                return !item.bottomDropZone;
              })
              await this.addStepElementsToPdf(doc, filtered, step);
            }
            this.addOffsetTop(2);
          }
          for (let j = 0; j < step.panels.length; j++) {
            const {uuid} = step.panels[j];
            const elements = this.getElementsByPanel(uuid, config.global, step, j === 0);
            const filtered = elements.filter(item => {
              return !item.bottomDropZone;
            })
            await this.addStepElementsToPdf(doc, filtered, step);
          }
          this.setOffsetTop(slideImageTopOffset);
          doc.setPage(pageNumber);
        }

        if (!images[id]) {
          images[id] = await this.loadExportSlideImage(projectId, slide, i, loadingMode, this.pdf.imageQuality).catch(() => {
            //console.log(e);
            console.log('could not load slide ' + slides[i].id)
          });
        }

        //draw slides on first step page, then continue from last page
        //add step slide images
        if (images[id]) {
          const image = images[id];
          // Use the source ratio for layout: integer pixel rounding must not
          // move content or page breaks when quality changes.
          const {width, height} = fitImage(image.sourceWidth, image.sourceHeight, {
            width: slideImageWidth,
            height: this.pdfConfig.PAGE_HEIGHT - this.pdfConfig.NEW_PAGE_TOP_OFFSET,
          }, true);
          if (this.getOffsetTop() > this.pdfConfig.MAX_IMAGE_TOP_OFFSET ||
              this.getOffsetTop() + height > this.pdfConfig.PAGE_HEIGHT) {
            this.addPageToPdf(doc);
          }

          doc.addImage(image.data, "png", 100, this.getOffsetTop(), width, height, undefined, 'FAST');
          this.addOffsetTop(height + 5);
          if (this.getOffsetTop() > this.pdfConfig.PAGE_HEIGHT) {
            this.addPageToPdf(doc);
          }
        }
      }

      this.pdf.processing = false;
      this.pdf.ExportProcessing = false;
      const date = this.pdf.initialDate ? this.pdf.initialDate : this.dateFromUnix(Date.now());
      doc.save(`${this.projectName ? this.projectName : 'projekt'}-${date}.pdf`);
      this.pdf.initialDate = null;
    },
    /*renderGlobalsForStep(uuid) {
      if(this.pdf.renderGlobalPanels) {
        // todo

      }
    },*/
    addPageToPdf(doc) {
      doc.addPage();
      this.addHeaderFooter(doc);
      this.resetOffsetTop();
    },
    addHeaderFooter(doc) {
      const {website, name, logo} = this.footer;
      let headerText = website ? `${name} - ${website}` : `${this.projectName ? this.projectName : name}`;
      let footerText = `${this.pdf.footerData}`;
      const headerTextLeftOffset = (doc.internal.pageSize.getWidth() - doc.getTextWidth(headerText)) / 2;
      const footerTextLeftOffset = (doc.internal.pageSize.getWidth() - doc.getTextWidth(footerText)) / 2;

      //logo header & footer
      if (logo) {
        const height = this.calculateImageHeight(doc, logo, 15);
        doc.addImage(logo, "png", 10, 2, 15, height);
        doc.addImage(logo, "png", 10, 280, 15, height);
      }

      //header text
      doc.text(headerText, headerTextLeftOffset, 8);
      doc.line(10, 14, 200, 14);

      //footer text
      doc.text(footerText, footerTextLeftOffset, 286);
      doc.line(10, 278, 200, 278);

      //page number
      doc.text(doc.getCurrentPageInfo().pageNumber.toString(), 197, 286);
    },
    calculateImageHeight(doc, imageBase64, width) {
      const imageProps = doc.getImageProperties(imageBase64);
      return imageProps.height * width / imageProps.width;
    },
    getSvgAspectRatio(svgString) {
      const doc = new DOMParser().parseFromString(svgString, "image/svg+xml");
      const svg = doc.documentElement;

      const parse = v => v ? parseFloat(v) : null;

      let width = parse(svg.getAttribute("width"));
      let height = parse(svg.getAttribute("height"));

      if (width && height) {
        return height / width;
      }

      const viewBox = svg.getAttribute("viewBox");
      if (viewBox) {
        const [, , vbWidth, vbHeight] = viewBox.split(/\s+/).map(Number);
        if (vbWidth && vbHeight) {
          return vbHeight / vbWidth;
        }
      }

      // Browser fallback default for <img>
      return 150 / 300; // 0.5
    },
    calculateSvgHeight(svgString, targetWidth) {
      return targetWidth * this.getSvgAspectRatio(svgString);
    },
    addHeadline(doc, element) {
      const {elementsLeftOffset, isFormRTL} = this.pdfConfig;
      let fontSize = doc.getFontSize();
      doc.setFontSize(16);
      this.addOffsetTop(3);
      this.addTextToPdf({
        doc,
        leftOffset: isFormRTL ? elementsLeftOffset + 80 : elementsLeftOffset,
        text: this.getLabel(element, this.$store.getters.getSelectedFormLanguage),
        maxlen: 78,
        textAlign: isFormRTL ? 'right' : 'left',
      })
      doc.setFontSize(fontSize);
    },
    addWebsite(doc, element) {
      if (element.url) {
        const {elementsLeftOffset, isFormRTL} = this.pdfConfig;
        this.addOffsetTop(3);
        this.addTextToPdf({
          doc,
          leftOffset: isFormRTL ? elementsLeftOffset + 80 : elementsLeftOffset,
          text: this.getLabel(element, this.$store.getters.getSelectedFormLanguage),
          maxlen: 78,
          textAlign: isFormRTL ? 'right' : 'left',
        })
        let color = doc.getTextColor();
        doc.setTextColor("#0000FF");
        this.addTextToPdf({
          doc,
          leftOffset: isFormRTL ? elementsLeftOffset + 80 : elementsLeftOffset,
          text: element.url.dix[this.$store.getters.getSelectedFormLanguage],
          maxlen: 78,
          textAlign: isFormRTL ? 'right' : 'left',
        })
        doc.setTextColor(color);
      }
    },
    /**
     * @returns height of the element
     * */
    async addImage(doc, element/*, nextElement*/) {
      const {topOffset, standardImageWidth, tileWidth} = this.pdfConfig;
      const {showastiles} = element;
      const imageId = this.getImage(element, this.$store.getters.getSelectedFormLanguage)
      if (imageId) {
        let imageData = this.$store.getters.getFormImageById(imageId);
        if (!imageData) {
          imageData = await this.getAssetFileAsBase64(imageId);
        }
        console.log('image data', imageData)

        if (imageData) {
          const pdfImageWidth = showastiles ? tileWidth : standardImageWidth;
          const height = await this.addImageOrSvg(imageData, doc, this.getLeftOffset(element), topOffset, pdfImageWidth);
          return showastiles ? this.getCurrentRowHeight() : height;
        }
      }
      console.log('error, image id missing')
      return 0;
    },
    async addImageOrSvg(imageData, doc, leftOffset, topOffset, pdfImageWidth) {
      if (!imageData) {
        return 0;
      }
      const isSVG = imageData.includes('svg');
      if (!isSVG) {
        let height = this.calculateImageHeight(doc, imageData, pdfImageWidth);
        // todo: issues with certain imgs SFX-3946
        console.log('adding image with height', height)
        console.log('left offset', leftOffset, 'top offset', topOffset)
        console.log('width', pdfImageWidth)
        doc.addImage(imageData, "png", leftOffset, topOffset, pdfImageWidth, height);
        return height;
      } else {
        //svg handling
        return await this.svgToPngDataUrl(imageData, pdfImageWidth)
            .then(newImageData => {
              const height = this.calculateImageHeight(doc, newImageData, pdfImageWidth);
              doc.addImage(newImageData, "png", leftOffset, topOffset, pdfImageWidth, height);
              return height;
            });
      }
    },
    async svgToPngDataUrl(svgString, targetWidthPx, scale = 4) {
      const heightPx = this.calculateSvgHeight(svgString, targetWidthPx);

      return new Promise((resolve, reject) => {
        const blob = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
        const url = URL.createObjectURL(blob);

        const img = new Image();
        img.onload = () => {
          const dpr = window.devicePixelRatio || 1;
          const s = scale * dpr;

          const canvas = document.createElement("canvas");
          canvas.width = Math.round(targetWidthPx * s);
          canvas.height = Math.round(heightPx * s);

          const ctx = canvas.getContext("2d");
          ctx.setTransform(s, 0, 0, s, 0, 0); // scale drawing ops
          ctx.drawImage(img, 0, 0, targetWidthPx, heightPx);

          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL("image/png"));
        };

        img.onerror = (e) => {
          URL.revokeObjectURL(url);
          reject(e);
        };
        img.src = url;
      });
    },
    async addSVGToDOMGetItAsImageData(svgString, targetWidth) {
      const height = this.calculateSvgHeight(svgString, targetWidth);

      return new Promise((resolve, reject) => {
        const svgBlob = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
        const url = URL.createObjectURL(svgBlob);

        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = Math.round(targetWidth);
          canvas.height = Math.round(height);

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height); // 👈 important

          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL("image/png"));
        };

        img.onerror = (e) => {
          URL.revokeObjectURL(url);
          reject(e);
        };

        img.src = url;
      });
    },
    setIsOdd(bool) {
      this.pdfConfig.tileOdd = bool;
    },
    getIsOdd() {
      return this.pdfConfig.tileOdd;
    },
    getLeftOffset(element) {
      const {elementsLeftOffset, tileWidth} = this.pdfConfig;
      if (!element.showastiles) {
        return elementsLeftOffset;
      }
      return this.getIsOdd() ? elementsLeftOffset : (elementsLeftOffset + tileWidth + 2);
    },
    getLeftButtonImageOffset(element) {
      const {elementsLeftOffset} = this.pdfConfig;
      if (element.showastiles) {
        return this.getIsOdd() ? elementsLeftOffset + 3 : elementsLeftOffset + 44;
      } else {
        return elementsLeftOffset + 3;
      }
    },
    async addShortAnswer(doc, element, data = {}) {
      const {elementsLeftOffset, minHeightForShortAnswerBox, isFormRTL} = this.pdfConfig;

      let height = minHeightForShortAnswerBox;
      let text = this.getLabel(element, this.$store.getters.getSelectedFormLanguage);
      if (element.isRequired) {
        text += " *";
      }
      this.addOffsetTop(3);
      this.addTextToPdf({
        doc,
        leftOffset: isFormRTL ? elementsLeftOffset + 80 : elementsLeftOffset,
        text,
        maxlen: 78,
        textAlign: isFormRTL ? 'right' : 'left',
      })

      // variant 1: component logs
      if (this.pdf.useComponentLogs && element.logId) {
        height = await this.addShortAnswerWithComponentLogs(doc, element)
        // variant 2: logs from the logger
      } else if (data && data.answers.length) {
        const answer = data.answers[0].answer;
        height = this.addShortAnswerWithDefaultLogs(doc, answer)
        // variant 3: empty textbox
      } else {
        height = this.addShortAnswerWithoutLogs(doc);
      }

      return height;
    },
    addShortAnswerWithoutLogs(doc) {
      const {maxLengthForShortAnswerText, minHeightForShortAnswerBox} = this.pdfConfig;
      this.drawRect(doc, maxLengthForShortAnswerText + 10, this.getOffsetTop(), minHeightForShortAnswerBox);
      return minHeightForShortAnswerBox;
    },
    addShortAnswerWithDefaultLogs(doc, answer) {
      const offset = this.getOffsetTop();
      this.addOffsetTop(-3);
      const {elementsLeftOffset, maxLengthForShortAnswerText} = this.pdfConfig;
      const {
        height,
        isNewPage
      } = this.addUnseparableText(doc, elementsLeftOffset + 5, answer, maxLengthForShortAnswerText, 13)
      console.log(isNewPage) // todo: this should be handled properly
      this.setOffsetTop(offset); // reset the offset to its previous position
      const paddingTop = 13;
      this.drawRect(doc, maxLengthForShortAnswerText + 10, this.getOffsetTop(), height + paddingTop);
      return height + paddingTop;
    },
    async addShortAnswerWithComponentLogs(doc, element) {
      const {elementsLeftOffset, maxLengthForShortAnswerText, minHeightForShortAnswerBox} = this.pdfConfig;
      let height = 0;
      doc.setFontSize(this.pdfConfig.FONT_SIZE - 2);
      this.drawRect(doc, maxLengthForShortAnswerText + 10, this.getOffsetTop(), minHeightForShortAnswerBox);
      this.addOffsetTop(minHeightForShortAnswerBox + 5);
      const logString = await this.retrieveComponentLogEntries(element.logId, element.uuid);
      if (logString) {
        let {height: tmpHeight} = this.addTextToPdf({
          doc,
          leftOffset: elementsLeftOffset,
          text: logString,
          maxlen: maxLengthForShortAnswerText + 10
        })
        height = tmpHeight;
      }
      doc.setFontSize(this.pdfConfig.FONT_SIZE);
      return height;
    },
    drawRect(doc, width, offset, height) {
      doc.setDrawColor(120, 120, 120);
      doc.rect(10, offset, width, height);
      doc.setDrawColor(0, 0, 0);
    },
    async retrieveComponentLogEntries(logId, elementId) {
      return await this.$store.dispatch('clientLoadDatasetRows', {
        id: logId,
        filter: 'key eq ' + elementId
      }).then(data => {
        const res = data.length ? data.map(item => {
          return item.data
        }) : [];
        let fullString = "";
        for (let i = 0; i < res.length; i++) {
          const {userId, time, data} = res[i];
          if (data) {
            const string = `${userId ? userId + ' ' : ''}${time ? time : ''}`;
            const printString = string ? (string + '\n' + data) : data;
            if (i > 0) {
              fullString += '\n\n';
            }
            fullString += printString;
          }
        }
        return fullString;
      }).catch(e => {
        console.log(e);
        console.log('no component log data found')
      })
    },
    async getButtonImage(element) {
      let imageId = this.getImage(element, this.$store.getters.getSelectedFormLanguage);
      let image = null;
      if (imageId) {
        image = this.$store.getters.getFormImageById(imageId);
        if (!image) {
          image = await this.getAssetFileAsBase64(imageId);
        }
      }
      return image;
    },
    /**
     * @params doc - jsPDF document
     * @params element - button element
     * @params nextElement - next element after the button
     * @returns height of the element
     * */
    async addButton(doc, element, nextElement) {
      const {showastiles} = element;
      if (showastiles) {
        return await this.doTileButton({
          doc,
          element,
          nextElement,
        });
      } else {
        return await this.doNormalButton({
          doc,
          element,
          nextElement
        })
      }
    },
    async doNormalButton(args) {
      const {doc, element, nextElement} = args;
      const {isFormRTL} = this.pdfConfig;
      const image = await this.getButtonImage(element);
      const text = this.getLabel(element, this.$store.getters.getSelectedFormLanguage);

      const paddingTop = 3;
      const paddingLeft = 3;
      const maxLength = image ? 60 : 70;
      const defaultImgWidth = 10;
      let imgHeight = 0;
      const buttonOffsetLeft = this.getLeftOffset(element, nextElement);
      let tempTopOffset = this.getOffsetTop() + paddingTop;
      const originalOffset = this.getOffsetTop();

      // 1 - add image if available
      if (image) {
        let imageOffsetLeft = buttonOffsetLeft + 3;
        if (isFormRTL) {
          imageOffsetLeft = buttonOffsetLeft + 80 - defaultImgWidth - 3;
        }
        imgHeight = await this.addImageOrSvg(image, doc, imageOffsetLeft, tempTopOffset, defaultImgWidth);
      }

      const lineHeight = this.getLineHeight();
      const textLines = doc.splitTextToSize(text, maxLength, null);
      const textHeight = textLines.length * (lineHeight * 0.352777778); // convert pt to mm
      const buttonWidth = 80;

      // todo: the condition for multiple lines doesn't work properly - works fine for 2 lines, but not for 3 or more, will leave this for now
      const textContentHeight = textLines.length > 1 ? (textHeight + (textLines.length * 1.5)) : textHeight;
      const singleLineHeight = lineHeight * 0.352777778;
      let textOffsetTop = 0;
      // text only
      if(!image || imgHeight === 0) {
          textOffsetTop = originalOffset + paddingTop + singleLineHeight;
        // debugging rect
          /*doc.setDrawColor(255, 0, 0);
          doc.rect(buttonOffsetLeft, 129.7, 80, textHeightInPt + paddingTop * 2);
          doc.setDrawColor(0, 0, 0);*/
      } else if(imgHeight) {
        // text will be vertically centered to the image
        // todo: works fine for single line text, but not for multiple lines more than 2
        textOffsetTop = originalOffset + paddingTop + (textLines.length === 1 ? singleLineHeight : 0) + ((imgHeight - textHeight) / 2);
      }

      //const textOffsetLeft = image ? buttonOffsetLeft + defaultImgWidth + (paddingLeft + 2) : buttonOffsetLeft + paddingLeft;
      let textOffsetLeft = 0;
      if(image) {
        if(isFormRTL) {
          textOffsetLeft = buttonOffsetLeft + buttonWidth - defaultImgWidth - paddingLeft - 2;
        } else {
          textOffsetLeft = buttonOffsetLeft + defaultImgWidth + paddingLeft + 2;
        }
      } else {
        if(isFormRTL) {
          textOffsetLeft = buttonOffsetLeft + buttonWidth - paddingLeft;
        } else {
          textOffsetLeft = buttonOffsetLeft + paddingLeft;
        }
      }

      // 2 - add text
      this.addTextToPdf({
        doc,
        leftOffset: textOffsetLeft,
        topOffset: textOffsetTop,
        text: text,
        maxlen: maxLength,
        textAlign: isFormRTL ? 'right' : 'left'
      });

      const contentHeight = Math.max(imgHeight, textContentHeight);
      const calculatedHeight = contentHeight + (paddingTop * 2);
      /*
      *  offsetY: buttonOffsetLeft - paddingLeft,
        offsetX: this.getOffsetTop(),
      * */
      this.doButtonRect({
        doc,
        offsetX: buttonOffsetLeft,
        offsetY: originalOffset,
        width: buttonWidth,
        height: calculatedHeight
      });

      this.setOffsetTop(originalOffset);
      this.addOffsetTop(calculatedHeight + 2);
    },
    setCurrentRowHeight(rowHeight) {
      this.pdfConfig.currentRowHeight = rowHeight;
    },
    getCurrentRowHeight() {
      return this.pdfConfig.currentRowHeight;
    },
    /**
     * This function is called before adding a tile
     * it resets the current row height if the tile is the first in a row
     * */
    prepareTile() {
      // 1 - if the first tile of two in a row: reset the current row height
      // this seems unnecessary because aftertile already does this, but if there isn't a second tile on a row, the height would be wrong
      if (this.getIsOdd()) {
        this.setCurrentRowHeight(0);
      }
    },
    /**
     * This function is called after adding a tile
     * it sets the current row height if the tile is the second in a row or resets it if it's the first
     * and toggles the isOdd flag
     * */
    afterTile(customTileHeight = null) {
      const {tileHeight} = this.pdfConfig;
      // after adding a tile: if the current tile is odd: set the tileHeight as the default height for the row
      if (this.getIsOdd()) {
        this.setCurrentRowHeight(customTileHeight);
      } else {
        this.setCurrentRowHeight(tileHeight);
      }
      this.setIsOdd(!this.getIsOdd());
    },
    async doTileButton(args) {
      const {doc, element, nextElement} = args;
      let {tileWidth, tileHeight, isFormRTL} = this.pdfConfig;
      this.prepareTile();
      tileHeight = this.getCurrentRowHeight() || tileHeight;
      if(!element) {
        throw new Error('element is required for doTileButton');
      }
      let imgHeight = 0;
      const paddingTop = 3;
      const paddingLeft = 3;

      const image = await this.getButtonImage(element);
      const text = this.getLabel(element, this.$store.getters.getSelectedFormLanguage);
      const buttonOffsetLeft = this.getLeftOffset(element, nextElement) + paddingLeft;
      let tempTopOffset = this.getOffsetTop();
      const originalOffset = this.getOffsetTop();

      tempTopOffset += paddingTop;

      // 1 - add image if available
      if (image) {
        const pdfImageWidth = 35;
        imgHeight = await this.addImageOrSvg(image, doc, buttonOffsetLeft, tempTopOffset, pdfImageWidth);
        tempTopOffset += paddingTop;// padding top is added twice to have space above and below the image
        tempTopOffset += imgHeight;
      } else {
        tempTopOffset += paddingTop; // if no image: add extra padding
      }

      let textOffsetLeft = buttonOffsetLeft;
      if(isFormRTL) {
        textOffsetLeft = buttonOffsetLeft + tileWidth - paddingLeft * 2;
      }
      // 2 - add text
      const {
        height,
        //isNewPage
      } = this.addTextToPdf({
        doc,
        leftOffset: textOffsetLeft,
        topOffset: tempTopOffset,
        text: text,
        maxlen: tileWidth - (paddingTop * 2),
        textAlign: isFormRTL ? 'right' : 'left'
      });

      // 3 - draw button rect
      const contentHeight = height + imgHeight + (paddingTop * 2);
      const calculatedHeight = Math.max(contentHeight, tileHeight);
      this.doButtonRect({
        doc,
        offsetX: buttonOffsetLeft - paddingLeft,
        offsetY: this.getOffsetTop(),
        width: tileWidth,
        height: calculatedHeight
      });

      this.afterTile(calculatedHeight); // toggle odd/even and set row height

      // if next element is no tile: add offset top to the elements height
      if (!nextElement || !nextElement.showastiles) {
        this.setIsOdd(true);
      }
      this.setOffsetTop(originalOffset);

      return calculatedHeight;
    },
    doButtonRect(args) {
      const {doc, offsetY, offsetX, width, height} = args;
      doc.setDrawColor(120, 120, 120);
      doc.rect(offsetX, offsetY, width, height);
      doc.setDrawColor(0, 0, 0);
    },
    drawButtonRect(doc, offsetY, offsetX, width, height) {
      doc.setDrawColor(220, 220, 220);
      doc.rect(offsetY, offsetX, width, height);
      doc.setDrawColor(0, 0, 0);
    },
    addCheckBoxes(doc, element, type = "checkbox", data) {
      this.addOffsetTop(2);
      const {elementsLeftOffset, isFormRTL} = this.pdfConfig;

      let text = this.getLabel(element, this.$store.getters.getSelectedFormLanguage);
      if (element.isRequired) {
        text += " *";
      }

      const checkboxWidth = 4;
      let textOffsetLeft = elementsLeftOffset + checkboxWidth + 2;
      let questionTextOffsetLeft = elementsLeftOffset;
      let checkboxOffsetLeft = elementsLeftOffset;
      if(isFormRTL) {
        textOffsetLeft = elementsLeftOffset + 80 - checkboxWidth - 2;
        questionTextOffsetLeft = elementsLeftOffset + 80;
        checkboxOffsetLeft = elementsLeftOffset + 76;
      }
      this.addTextToPdf({
        doc,
        leftOffset: questionTextOffsetLeft,
        text: text,
        maxlen: 78,
        textAlign: isFormRTL ? 'right' : 'left'
      })

      for (let idx = 0; idx < element.options.length; idx++) {
        let option = element.options[idx];
        const isSelected = data && data.answers ? this.getMatchingOption(option, data.answers) : false;
        if(type === "checkbox") {
          if (isSelected) {
            doc.setFillColor(0, 0, 0);
            doc.rect(checkboxOffsetLeft + 1, this.getOffsetTop() + 1, 2, 2, 'F');
          }
          doc.rect(checkboxOffsetLeft, this.getOffsetTop(), checkboxWidth, checkboxWidth);
        } else {
          const radius = 2;
          if (isSelected) {
            doc.setFillColor(0, 0, 0);
            doc.circle(checkboxOffsetLeft + 2, this.getOffsetTop() + radius, radius - 1, 'F');
          }
          doc.circle(checkboxOffsetLeft + 2, this.getOffsetTop() + radius, radius);
        }

        this.addOffsetTop(3.3);
        this.addTextToPdf({
          doc,
          leftOffset: textOffsetLeft,
          text: this.getText(option, this.$store.getters.getSelectedFormLanguage),
          maxlen: 70,
          textAlign: isFormRTL ? 'right' : 'left'
        })
      }
    },
    addSeparator(doc, element) {
      const {elementsLeftOffset} = this.pdfConfig;
      const height = element.height ? element.height / 10 : 5;
      this.addOffsetTop(height);
      doc.line(elementsLeftOffset, this.getOffsetTop(), elementsLeftOffset + 80, this.getOffsetTop());
      this.addOffsetTop(height);
    },
    convertHTMLToText(htmlString) {
      console.log('converting html to text: ', htmlString);
      const {isFormRTL} = this.pdfConfig;
      // todo: ol, ul, b and i need to be converted into proper text formatting
      const root = parse(htmlString);
      const out = [];
      root.childNodes.forEach(node => {
        if (node.nodeType === 3) { // text node
          out.push(node.rawText);
        } else if (node.nodeType === 1) { // element node
          if (node.tagName === 'BR') {
            out.push('\n');
          } else if (node.tagName === 'P') {
            out.push(this.convertHTMLToText(node.innerHTML) + '\n\n');
          } else if (node.tagName === 'B' || node.tagName === 'STRONG') {
            out.push('**' + this.convertHTMLToText(node.innerHTML) + '**');
          } else if (node.tagName === 'I' || node.tagName === 'EM') {
            out.push('*' + this.convertHTMLToText(node.innerHTML) + '*');
          } else if (node.tagName === 'UL') {
            let items = node.querySelectorAll('li').map(li => '- ' + this.convertHTMLToText(li.innerHTML)).join('\n');
            if(isFormRTL) {
              // put the dash at the end of the line for rtl languages
              items = node.querySelectorAll('li').map(li => this.convertHTMLToText(li.innerHTML) + ' -').join('\n');
            }
            out.push(items + '\n');
          } else if (node.tagName === 'OL') {
            let items = node.querySelectorAll('li').map((li, index) => (index + 1) + '. ' + this.convertHTMLToText(li.innerHTML)).join('\n');
            if(isFormRTL) {
              // put the number at the end of the line for rtl languages
               items = node.querySelectorAll('li').map((li, index) => this.convertHTMLToText(li.innerHTML) + ' ' + (index + 1) + '.').join('\n');
            }
            out.push(items + '\n');
          } else {
            out.push(this.convertHTMLToText(node.innerHTML));
          }
        }
      });
      return out.join('');
    },
    async addStepElementsToPdf(doc, elements, step) {
      const {elementsLeftOffset, PAGE_HEIGHT, isFormRTL} = this.pdfConfig;
      let height = 0;
      for (let i = 0; i < elements.length; i++) {
        let element = elements[i];
        const nextElement = elements[i + 1] ? elements[i + 1] : null;
        /*if (i > 0 && element.panelUuid !== elements[i - 1].panelUuid) {
          this.addOffsetTop(10);
        }*/
        const data = this.getNewestLogEntryForElement(element, step);
        const {formElementTypeString} = element;
        if (this.getOffsetTop() + 10 > PAGE_HEIGHT) {
          this.addPageToPdf(doc);
        }
        if (formElementTypeString === vFormControls.HEADLINE) {
          this.addHeadline(doc, element)
        } else if (formElementTypeString === vFormControls.WEBSITE) {
          this.addWebsite(doc, element)
        } else if (formElementTypeString === vFormControls.TEXT) {
          let text = this.getLabel(element, this.$store.getters.getSelectedFormLanguage);
          if (text && text.includes('<')) {
            text = this.convertHTMLToText(text);
          }
          this.addOffsetTop(3);
          this.addTextToPdf({
            doc,
            leftOffset: isFormRTL ? elementsLeftOffset + 80 : elementsLeftOffset,
            text,
            maxlen: 78,
            textAlign: isFormRTL ? 'right' : 'left'
          })
        } else if (formElementTypeString === vFormControls.IMAGE) {
          height = await this.addImage(doc, element, nextElement);
          if(!element.showastiles) {
            this.addOffsetTop(height + 2);
          }
          console.log('added image with height: ', height);
        } else if ([vFormControls.SHORT_ANSWER, vFormControls.LOGIN].includes(formElementTypeString)) {
          height = await this.addShortAnswer(doc, element, data);
          this.addOffsetTop(height + 2);
        } else if (formElementTypeString === vFormControls.BUTTON) {
          height = await this.addButton(doc, element, nextElement);
        } else if (formElementTypeString === vFormControls.CHECKBOXES) {
          this.addCheckBoxes(doc, element, "checkbox", data);
        } else if (formElementTypeString === vFormControls.RADIOBUTTONS) {
          this.addCheckBoxes(doc, element, "radio", data);
        } else if (formElementTypeString === vFormControls.SEPARATOR) {
          this.addSeparator(doc, element);
        } else if (formElementTypeString === vFormControls.VERTICAL_SPACE) {
          this.addOffsetTop(element.height ? element.height / 5 : 4);
        } else {
          console.log('Unsupported form element type for PDF export: ', formElementTypeString);
        }

        // go to next row if:
        // - current element is shown as tiles and we are on an even tile (second tile)
        // - next element is not shown as tiles (we need to go to the next row)
        if ((element.showastiles && this.getIsOdd()) || (nextElement && !nextElement.showastiles)) {
          if(height) {
            this.addOffsetTop(height + 2)
          }
        }
        height = 0;
      }
    },
    getLineHeight() {
      return this.pdfConfig.FONT_SIZE / 2
    },
    addUnseparableText(doc, leftOffset = 10, text, maxlen = 80, paddingTop = 0) {
      return this.addTextToPdf({
        doc,
        leftOffset,
        text,
        maxlen,
        textIsUnseparable: true,
        paddingTop
      })
    },
    getMaxRowsOnCurrentPage() {
      const lineHeight = this.getLineHeight();
      let maxRows = Math.floor((this.pdfConfig.PAGE_HEIGHT - this.getOffsetTop()) / lineHeight);
      if (maxRows < 0) {
        console.log('Layout error: max rows on current page is less than 0');
        maxRows = 0;
      }
      return maxRows;
    },
    /**
     * Add text – attention: text y position is at the bottom line of the text
     * @returns height of the added text and whether a new page was added
     * */
    addTextToPdf(args) {
      let {doc, leftOffset = 10, topOffset = 'auto', text, maxlen = 80, textIsUnseparable = false, paddingTop = 0, textAlign = "left"} = args;
      let top = 0;
      if (!text) {
        return {height: 0, isNewPage: false};
      }

      try {
        text = decodeURIComponent(text);
      } catch {
        // do nothing
      }
      if (paddingTop) {
        this.addOffsetTop(paddingTop);
      }

      const lineHeight = this.getLineHeight();

      let res = doc.splitTextToSize(text, maxlen, null);
      let maxRowsOnCurrentPage = this.getMaxRowsOnCurrentPage(doc);
      let willTextCausePageOverflow = res.length > maxRowsOnCurrentPage;
      if (textIsUnseparable) {
        this.addPageToPdf(doc);
        maxRowsOnCurrentPage = this.getMaxRowsOnCurrentPage(doc);
        willTextCausePageOverflow = false; // we asume that unseparable text fits on a new page
      }
      if (willTextCausePageOverflow) {
        // add the first part of the text that fits on the current page
        top = this.addTextLines({
          lines: res.slice(0, maxRowsOnCurrentPage),
          doc,
          leftOffset,
          topOffset,
          lineHeight,
          entriesLength: maxRowsOnCurrentPage,
          top,
          textAlign
        })
        this.addPageToPdf(doc);
        // add the rest of the text on the new page

        const restLength = res.length - maxRowsOnCurrentPage;
        top = this.addTextLines({
          lines: res.slice(maxRowsOnCurrentPage),
          doc,
          leftOffset,
          topOffset,
          lineHeight,
          entriesLength: restLength,
          top,
          textAlign
        })
      } else {
        top = this.addTextLines({
          lines: res,
          doc,
          leftOffset,
          topOffset,
          lineHeight,
          entriesLength: res.length,
          top,
          textAlign
        })
      }
      return {height: top, isNewPage: willTextCausePageOverflow};
    },
    addTextLines(args) {
      let {lines, doc, leftOffset, topOffset = 'auto', lineHeight, entriesLength, top = 0, textAlign = "left"} = args;
      let tempOffsetTop = topOffset;
      //lines = lines.filter(line => line && line.trim().length > 0);
      if(!entriesLength) {
        entriesLength = lines.length;
      }
      if(entriesLength > lines.length) {
        entriesLength = lines.length;
      }
      for (let i = 0; i < entriesLength; i++) {
        const finalOffsetTop = tempOffsetTop === 'auto' ? this.getOffsetTop() : tempOffsetTop;
        doc.text(lines[i], leftOffset, finalOffsetTop, { align: textAlign });
        top += lineHeight
        if (tempOffsetTop === 'auto') {
          this.addOffsetTop(lineHeight)
        } else if(lines[i + 1]) { // only increase tempOffsetTop if there is a next line
          tempOffsetTop += lineHeight;
          top += lineHeight;
        }
      }
      return top;
    }
  },
}
</script>
